import { useState, useEffect } from "react";
import Aos from "aos";
import "aos/dist/aos.css";
import { sendEmail } from "../modules/EmailUtils";
import "./contact.css";

const Contact = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const doSendEmail = (e: any) => {
    e.preventDefault();
    sendEmail(firstName, lastName, phone, email, message)
      .then(() => {
        setFirstName("");
        setLastName("");
        setPhone("");
        setEmail("");
        setMessage("");
        // eslint-disable-next-line no-alert
        alert("your email received, thank you!");
      })
      .catch((error) => {
        // eslint-disable-next-line no-alert
        alert(error.message);
      });
  };
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);
  return (
    <section className="contact" id="contact">
      <div className="container1">{}</div>
      <h2> Contact Us</h2>
      <div data-aos="fade-down" className="contact-box ">
        <div className="contact-form" id="contact">
          <form action="/" method="POST" id="my-form">
            <h3 className="title">Do you have a Project or Question?</h3>
            <div className="row">
              <input
                type="text"
                className="contact-input"
                placeholder="First Name "
                name="firstName"
                value={firstName}
                onChange={(e) => {
                  setFirstName(e.target.value);
                }}
                required
              />
              <input
                type="text"
                className="contact-input"
                placeholder="Last Name"
                name="lastName"
                value={lastName}
                onChange={(e) => {
                  setLastName(e.target.value);
                }}
                required
              />
            </div>

            <div className="row">
              <input
                type="text"
                className="contact-input"
                placeholder="Phone"
                name="phone"
                value={phone}
                onChange={(e) => {
                  setPhone(e.target.value);
                }}
              />
              <input
                type="email"
                className="contact-input"
                placeholder="E-mail"
                name="replyTo"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
                required
              />
            </div>

            <div className="row">
              <textarea
                name="message"
                className="contact-input textarea"
                placeholder="Your Message"
                value={message}
                onChange={(e) => {
                  setMessage(e.target.value);
                }}
                required
              >
                {}
              </textarea>
            </div>
            <div className="row">
              <button type="submit" className="btn" onClick={doSendEmail}>
                Send
              </button>
              <div className="text" id="status">
                {" "}
              </div>
            </div>
          </form>
        </div>
        <div className="map">
          <h3 className="title">Visit us</h3>

          <iframe
            title="myFrame"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1437.4026789263694!2d46.21423256127189!3d31.033521028934!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xbda328e8ed2ccaec!2zMzHCsDAyJzAxLjQiTiA0NsKwMTInNDguMyJF!5e0!3m2!1sar!2sae!4v1648459571544!5m2!1sar!2sae"
            frameBorder="3"
            style={{ border: 3 }}
          >
            {}
          </iframe>
          <div className="information-wrap">
            <div className="information">
              <div className="contact-icon">
                <i className="fas fa-map-marker-alt" />
              </div>
              <p className="info-text">Iraq - Nasiriyah - Mansourieh </p>
            </div>

            <div className="information">
              <div className="contact-icon">
                <i className="fas fa-phone" />
              </div>
              <p className="info-text">009647808071746</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
